<template>
  <div class="shippingDetails">
    <section class="detail_content">
      <div class="order-id-block">
        <span>
          Order ID:
          <b>#{{orderDetails.orderId}}</b>
        </span>
        <p>
          {{$t('currentState')}}:
           <b
            :class="{'cancel': subOrderDetails.suborderState =='CANCELLED_BY_USER','delivered': subOrderDetails.suborderState =='Delivered'}"
          >{{getText(subOrderDetails.suborderState)}}</b>
        </p>
      </div>

      <div class="product-card" v-if="subOrderDetails">
        <span class="product-img" v-if="subOrderDetails.itemImage" @click="goToProductDetail(subOrderDetails.saleReferenceID,'NORMAL')">
          <img :src="subOrderDetails.itemImage" alt />
        </span>
        <div class="product-detail">
          <div class="product-title">
            <h4>{{subOrderDetails.itemName}}</h4>
            <span class="product-price" v-if="orderDetails.orderAmount && parseFloat(orderDetails.codCharges) > 0">Rs. {{Math.round(parseFloat(orderDetails.orderAmount) + parseFloat(orderDetails.codCharges))}}.0</span>
              <span class="product-price" v-else>Rs. {{orderDetails.orderAmount}}</span>
          </div>
          <div class="color-size">
            <span class="product-color" v-if="subOrderDetails.color">
              {{$t('color')}} :&nbsp;
              <span class="colour">
                <span>{{subOrderDetails.color}}</span>
              </span> &nbsp;|
            </span>
            <span class="product-sz" v-if="subOrderDetails.size">
              {{$t('size')}} :&nbsp;
              <span class="size">{{subOrderDetails.size}}</span>
            </span>
          </div>
          <!-- <p v-if="!['ORDER_DELIVERED', 'CANCELLED_BY_SELLER', 'CANCELLED_BY_USER'].includes(orderDetails.orderState)">
            {{$t('deliveryDate')}}: {{ orderDetails.expectedDeliveryDate }} | {{$t('mode')}}:
            <span
              v-if="orderDetails.paymentMethod=='ZYK_PAY' || orderDetails.paymentMethod=='PAY91'"
            >Online</span>
            <span v-else>{{orderDetails.paymentMethod}}</span>
          </p> -->
        </div>
      </div>
      <div
        class="order-track-status"
        v-if="orderDetails.orderStateTransitionDTOs && orderDetails.orderStateTransitionDTOs.length > 0 "
      >
        <div class="order-state">
          <div
            class="instatus completed"
            v-for="(orderState,index) in orderDetails.orderStateTransitionDTOs"
            :key="index"
          >
            <h3>{{getText(orderState.orderState)}}</h3>
            <p>{{orderState.orderDate}}</p>
          </div>
        </div>
      </div>
      <div
        class="order-track-status refund_shipping"
        v-if="orderDetails.orderReturnDTO && orderDetails.orderStateTransitionDTOs.length>0"
      >
        <div class="order-state refund_track">
          <div
            class="instatus completed"
            v-for="(returnState,index) in orderDetails.orderReturnDTO.returnStateTransitionDTOs"
            :key="index"
          >
            <h3>{{getReturnText(returnState.orderReturnStatus)}}</h3>
            <p>{{returnState.actionDate}}</p>
          </div>
        </div>
        <div class="refundAddressbox">
          <div
            v-if="(orderDetails.orderReturnDTO.courierPartner=='INDIAPOST' && orderDetails.orderReturnDTO.orderReturnStatus=='INITIATED')"
          >
            <p
              class="infotext"
            >{{$t('courierOnGivenAddress')}}</p>
            <p class="textAddress">
              Rovi91 Innovations Pvt Ltd 1st floor Plot 140 Patparganj Industrial Area Delhi
              <br />Delhi - 110092
            </p>
          </div>

          <div
            v-if="(orderDetails.orderReturnDTO.courierPartner=='COURIER91' && orderDetails.orderReturnDTO.orderReturnStatus=='INITIATED')"
          >
            <p class="textAddress">
              {{$t('pleasePackUrCourierOrder', {personName:orderDetails.orderReturnDTO.courierProviderName})}}
              <br />
              {{orderDetails.orderReturnDTO.contactNumber}}
            </p>
          </div>
          <!-- <span class="bankDtlbtn" @click="addBankdetail()">Add refund detail</span> -->
          <div
            class="refundBtnpanel"
            v-if="(orderDetails.paymentMethod=='COD' && orderDetails.totalPaidAmount>0 && (orderDetails.orderReturnDTO.bankDetailsDTO==null || orderDetails.orderReturnDTO.bankDetailsDTO.paymentMode==null))"
          >
            <!-- <span class="bankDtlbtn" @click="addBankdetail()">{{$t('addBankDetail')}}</span> -->
            <span class="bankDtlbtn" @click="addBankdetail()">Add refund detail</span>
          </div>
        </div>
        <div class="cstmPopoverlayBG">
          <AddBankDetails :returnId="orderDetails.orderReturnDTO.id" />
        </div>        
      </div>
      <div
          class="tracking_details" v-if="!['RETURN_BY_USER','ORDER_DELIVERED','CANCELLED_BY_SELLER','CANCELLED_BY_USER'].includes(orderDetails.orderState) && orderDetails.trackingNumber"
        >
          <span class="track_order" @click="isTrackingDetails = !isTrackingDetails">
            {{$t('orderTrackingDetail')}}
            <i class="material-icons">keyboard_arrow_down</i>
          </span>
          <div class="demo" :class="{'tracking_info' : isTrackingDetails}">
            <p>
              <span class="color">{{$t('courierServiceName')}}:</span>
              {{orderDetails.courierPartner}}
            </p>
            <p>
              <span class="color">{{$t('trackingNumber')}}:</span>
              {{orderDetails.trackingNumber}}
            </p>
            <p v-if="orderDetails.orderOTP">
              <span class="color">{{$t('otpNumber')}}:</span>
              {{orderDetails.orderOTP}}
            </p>
             <p v-if="orderDetails.courier91AddressDTO">
              <span class="color">{{$t('partnerName')}}:</span>
              {{orderDetails.courier91AddressDTO.personName}}
            </p>
             <p v-if="orderDetails.courier91AddressDTO">
              <span class="color">{{$t('courierContactNo')}}:</span>
              {{orderDetails.courier91AddressDTO.contactNumber}}
            </p>
            <p v-if="orderDetails.trackingLink">
              <a
                :href="orderDetails.trackingLink"
                target="blank"
                style="border-bottom: 1px solid;"
              >{{$t('trackYourOrder')}}</a>
            </p>
          </div>
        </div>
    </section>
     <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>
<script>
import constant from "../../utils/constant";
import "../../assets/css/order-history.scss";
import ApiCaller from "../../utils/apicaller";
import AddBankDetails from "../OrderHistorySection/AddBankDetails";
export default {
  name: "TrackOrder",
  components: {
    AddBankDetails
  },
  data() {
    return {
      orderDetails: {},
      showCancel: true,
      subOrderDetails: {},
      loading: false,
      orderId: 0,
      CancelModal: false,
      isTrackingDetails: false
    };
  },
  methods: {
    goToProductReturnDetail() {
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push("/ProductReturn/" + this.$route.params.orderId);
    },

    addBankdetail() {
      document.querySelector("body").classList.add("bankDetailbody");
    },

    getReturnText(returnState) {
      let obj = constant.getReturnText;
      return obj[returnState];
    },

    getText(orderStatus) {
      let obj = constant.GETTEXT;
      return obj[orderStatus];
    },
    orderCancelModel() {
      this.loading = true;
      this.showCancel = false;
      this.CancelModal = false;
      var obj = {
        orderState: "CANCELLED_BY_USER"
      };
      this.$store
        .dispatch({
          type: "CancelUserOrder",
          payload: obj,
          orderId: this.orderId
        })
        .then(data => {
          this.$store.commit("saveData", {
            orders: [],
            orderIndex: 1,
            type: "post_order"
          });
          this.getOrdersById();
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          console.log(err)
        });
    },
    cancelOrder(orderId) {
      this.orderId = orderId;
      this.confrimText =
        "हमे दुःख है की आप यह आर्डर कैंसिल करना चाहते है! क्या आप सही मैं कैंसिल करना चाहते है ?";
      this.CancelModal = true;
    },

    getOrdersById() {
      this.loading = true;
      // this.$store
      //   .dispatch({
      //     type: "orderById",
      //     payload: this.$route.params.orderId
      //   })
        ApiCaller(constant.LOCAL_SHOP_URL_ORDER, "get-order-by-order-id/" + this.$route.params.orderId, "get")
        .then(data => {
          this.orderDetails = data.data;
          if (
            this.orderDetails &&
            this.orderDetails.subOrderDTOList &&
            this.orderDetails.subOrderDTOList.length > 0
          ) {
            this.subOrderDetails = this.orderDetails.subOrderDTOList[0];
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          console.log(err)
        });
    },

    goToProductDetail(productSrId, type) {
      this.$cookie.delete("type");
      this.$cookie.set("type", type);
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push("/detail/" + productSrId);
    }
  },
  mounted() {
    if (this.$route.params.orderId) {
      this.getOrdersById();
    }
  }
};
</script>
